module.exports = __webpack_public_path__ + "static/media/brandPostSuccess.c9c15a40.png";